module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img02-b2385adcb89c384e58769c6e12504f46.png";